<template>
    <el-scrollbar style="height: 85vh">
        <div class="room-page">
            <!-- 顶部房间信息 -->
            <div class="room-top-card">
                <div class="room-info">
                    <span class="label">门牌号：</span>
                    <span class="text">{{ roomInfo.doorplate }}</span>
                    <span class="label ml-4">房间名：</span>
                    <span class="text">{{ roomInfo.roomname }}</span>
                    <span class="label ml-4">余额：</span>
                    <span class="balance" :class="roomInfo.balance >= 0 ? 'plus' : 'minus'">￥{{ roomInfo.balance }}</span>
                </div>
            </div>

            <!-- 设备信息 + 控制 -->
            <div class="card mt-4">
                <el-tabs v-model="activeMeterId" @tab-click="handleMeterChange">
                    <el-tab-pane
                        v-for="meter in meterList"
                        :key="meter.meterid"
                        :label="`${meter.metername || meter.meteraddr}(${meter.typeText})`"
                        :name="meter.meterid"
                    />
                </el-tabs>

                <!-- 设备参数 -->
                <div class="meter-table-box mt-3">
                    <table class="grid-table">
                        <tr v-for="(row, idx) in currentMeterRows" :key="idx">
                            <template v-for="(item, i) in row" :key="i">
                                <td class="label">{{ item.label }}</td>
                                <td class="value" :class="{ highlight: item.highlight }">{{ item.value }}</td>
                            </template>
                        </tr>
                    </table>
                </div>

                <!-- 命令面板（组件化） -->
                <MeterCommandPanel :cmd-list="cmdList" @send="sendCmd" />
            </div>

            <!-- 用量图表 -->
            <div class="card mt-4">
                <div class="card-title">设备用量</div>
                <div ref="usageChartRef" style="width: 100%; height: 240px"></div>
            </div>

            <!-- 缴费 + 记录 -->
            <div class="pay-row">
                <div v-if="isJF" class="pay-left">
                    <div class="card p-4">
                        <el-form :model="payForm" label-width="100px">
                            <el-form-item label="缴费金额">
                                <el-input-number v-model="payForm.jine" style="width: 100%" />
                            </el-form-item>
                            <el-form-item label="缴费来源">
                                <el-select v-model="payForm.paytype" style="width: 100%">
                                    <el-option label="现金" value="0" />
                                    <el-option label="支付宝" value="1" />
                                    <el-option label="微信" value="2" />
                                    <el-option label="银联" value="3" />
                                    <el-option label="其他" value="254" />
                                </el-select>
                            </el-form-item>
                            <el-form-item label="备注">
                                <el-input v-model="payForm.mark" />
                            </el-form-item>
                            <el-form-item label="缴费类型">
                                <el-radio-group v-model="payForm.jiaofeitype">
                                    <el-radio value="0">预存</el-radio>
                                    <el-radio value="1">补助</el-radio>
                                    <el-radio value="2">退费</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" block @click="submitPay" :loading="payLoading">确认操作</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>

                <!-- 缴费记录 -->
                <div class="pay-right" :class="{ 'pay-right-full': !isJF }">
                    <div class="card">
                        <div class="card-title-bar">
                            <div class="card-title">缴费信息（近一年）</div>
                            <div class="table-tools">
                                <el-tooltip content="筛选列">
                                    <div style="display: inline-block">
                                        <el-popover trigger="click" placement="bottom" :width="220" v-model:visible="showPreCols">
                                            <div class="column-check-wrapper">
                                                <el-checkbox
                                                    v-for="c in preCols"
                                                    v-model="c.visible"
                                                    :key="c.prop"
                                                    class="block-checkbox"
                                                >
                                                    {{ c.label }}
                                                </el-checkbox>
                                            </div>
                                            <template #reference>
                                                <el-button circle size="small" type="primary" :icon="Filter"></el-button>
                                            </template>
                                        </el-popover>
                                    </div>
                                </el-tooltip>
                                <el-tooltip content="导出">
                                    <el-button
                                        circle
                                        size="small"
                                        type="primary"
                                        :icon="Download"
                                        @click="exportPrepaid"
                                    ></el-button>
                                </el-tooltip>
                                <el-tooltip content="打印">
                                    <el-button
                                        circle
                                        size="small"
                                        type="primary"
                                        :icon="Printer"
                                        @click="printPrepaid"
                                        style="margin-left: 0px"
                                    ></el-button>
                                </el-tooltip>
                            </div>
                        </div>

                        <el-table :data="prepaidList" border height="300">
                            <el-table-column
                                v-for="col in preCols.filter((c) => c.visible)"
                                :key="col.prop"
                                :label="col.label"
                                :prop="col.prop"
                                align="center"
                                :width="col.width"
                                :fixed="col.fixed"
                            >
                                <template v-if="col.prop === 'iscancel'" #default="scope">
                                    <el-tag :type="scope.row.iscancel ? 'danger' : 'success'">
                                        {{ scope.row.iscancel ? '是' : '否' }}
                                    </el-tag>
                                </template>
                                <template v-if="col.prop === 'action'" #default="scope">
                                    <el-button
                                        v-if="!scope.row.iscancel"
                                        type="danger"
                                        size="small"
                                        @click="cancelPrepaid(scope.row)"
                                    >
                                        取消
                                    </el-button>
                                    <el-button size="small" @click="printTicket(scope.row)">票据</el-button>
                                </template>
                            </el-table-column>
                        </el-table>

                        <Pagination
                            v-if="prepaidList.length"
                            :current-page="page_params.page"
                            :page-size="page_params.page_size"
                            :total="total"
                            @current-change="handleCurrentChange"
                            @size-change="handleSizeChange"
                        />
                    </div>
                </div>
            </div>

            <!-- 账单记录 -->
            <div class="card mt-4">
                <div class="card-title-bar">
                    <div class="card-title">账单信息（近三月）</div>
                    <div class="table-tools">
                        <el-tooltip content="筛选列">
                            <div style="display: inline-block">
                                <el-popover trigger="click" placement="bottom" :width="220" v-model:visible="showBillCols">
                                    <div class="column-check-wrapper">
                                        <el-checkbox
                                            v-for="c in billCols"
                                            v-model="c.visible"
                                            :key="c.prop"
                                            class="block-checkbox"
                                        >
                                            {{ c.label }}
                                        </el-checkbox>
                                    </div>
                                    <template #reference>
                                        <el-button circle size="small" type="primary" :icon="Filter"></el-button>
                                    </template>
                                </el-popover>
                            </div>
                        </el-tooltip>
                        <el-tooltip content="导出">
                            <el-button circle size="small" type="primary" :icon="Download" @click="exportBill"></el-button>
                        </el-tooltip>
                        <el-tooltip content="打印">
                            <el-button
                                circle
                                size="small"
                                type="primary"
                                :icon="Printer"
                                @click="printBill"
                                style="margin-left: 0px"
                            ></el-button>
                        </el-tooltip>
                    </div>
                </div>

                <el-table :data="billList" border height="390">
                    <el-table-column
                        v-for="col in billCols.filter((c) => c.visible)"
                        :key="col.prop"
                        :label="col.label"
                        :prop="col.prop"
                        align="center"
                    />
                </el-table>
            </div>

            <PaymentReceipt ref="printReceiptRef" />
        </div>
    </el-scrollbar>
</template>

<script setup>
import { ref, reactive, onMounted, nextTick } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import * as echarts from 'echarts'
import PaymentReceipt from './PaymentReceipt.vue'
import Pagination from '@/components/Pagination/index.vue'
import MeterCommandPanel from './MeterCommandPanel.vue'
import { Filter, Download, Printer } from '@element-plus/icons-vue'

// 基础
const roomId = ref(localStorage.getItem('roomId') || 1)
const isJF = true
const page_params = ref({ page: 1, page_size: 25 })
const total = ref(0)
const roomInfo = reactive({ doorplate: '101', roomname: '101', balance: -768.07 })

// 设备
const meterList = ref([])
const activeMeterId = ref('')
const currentMeterRows = ref([])
const cmdList = ref([])

// 图表
const usageChartRef = ref(null)
let usageChart = null

// 缴费
const payLoading = ref(false)
const payForm = reactive({ jine: 0, paytype: '0', mark: '', jiaofeitype: '0' })
const prepaidList = ref([])

// 账单
const billList = ref([])

// 筛选列
const showPreCols = ref(false)
const preCols = ref([
    { label: '房间编号', prop: 'roomcode', visible: true, width: 120 },
    { label: '房间名称', prop: 'roomname', visible: true },
    { label: '门牌号', prop: 'doorplate', visible: true },
    { label: '缴费金额', prop: 'paid', visible: true },
    { label: '缴费来源', prop: 'paytypeText', visible: true },
    { label: '缴费类型', prop: 'costtypeText', visible: true },
    { label: '缴费时间', prop: 'paydate', visible: true, width: 180 },
    { label: '上次余额', prop: 'lastbalance', visible: true },
    { label: '本次余额', prop: 'thisbalance', visible: true },
    { label: '缴费编码', prop: 'invoicenumber', visible: true, width: 200 },
    { label: '是否取消', prop: 'iscancel', visible: true },
    { label: '备注', prop: 'desc', visible: true, width: 200 },
    { label: '操作', prop: 'action', visible: true, width: 160, fixed: 'right' }
])

const showBillCols = ref(false)
const billCols = ref([
    { label: '账单', prop: 'scemename', visible: true },
    { label: '账单日期', prop: 'begindate', visible: true },
    { label: '生成日期', prop: 'enddate', visible: true },
    { label: '账单金额', prop: 'realamount', visible: true },
    { label: '账单计数', prop: 'quantity', visible: true },
    { label: '上次读数', prop: 'f_BillingQuantityBegin', visible: true },
    { label: '本次读数', prop: 'f_BillingQuantityEnd', visible: true },
    { label: '优惠', prop: 'discountamount', visible: true },
    { label: '违约金', prop: 'overdueamount', visible: true },
    { label: '最低消费补扣', prop: 'f_MinimalAmountOffsetting', visible: true },
    { label: '上次余额', prop: 'lastbalance', visible: true },
    { label: '本次余额', prop: 'thisbalance', visible: true },
    { label: '备注', prop: 'desc', visible: true }
])

// 打印票据
const printReceiptRef = ref(null)
const printTicket = (row) => {
    printReceiptRef.value.open(row)
}

// 发送命令
const sendCmd = (data) => {
    ElMessage.success('命令发送成功')
}

// 切换设备
const handleMeterChange = (tab) => {
    if (!tab.name) tab.name = tab.props.name
    const m = meterList.value.find((x) => x.meterid === tab.name)
    if (!m) return
    const list = [{ label: '设备地址', value: m.meteraddr, highlight: true }]
    m.meterfields.forEach((item) => {
        list.push({ label: item.f_Text + (item.f_Unit ? `(${item.f_Unit})` : ''), value: item.f_FieldValue })
    })
    list.push({ label: '通讯时间', value: m.linkdate, highlight: true })
    const rows = []
    for (let i = 0; i < list.length; i += 3) rows.push(list.slice(i, i + 3))
    currentMeterRows.value = rows
}

// 导出/打印工具函数
const exportTable = (list, cols, fileName) => {
    const show = cols.filter((c) => c.visible && c.prop !== 'action')
    const header = show.map((c) => c.label)
    const data = list.map((row) =>
        show.map((c) => {
            if (c.prop === 'iscancel') return row[c.prop] ? '是' : '否'
            return row[c.prop] ?? ''
        })
    )
    const csv = [header.join(','), ...data.map((r) => r.join(','))].join('\n')
    const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8' })
    const a = document.createElement('a')
    a.href = URL.createObjectURL(blob)
    a.download = fileName
    a.click()
    ElMessage.success('导出成功')
}

const printTable = (list, cols) => {
    const show = cols.filter((c) => c.visible && c.prop !== 'action')
    const th = show.map((c) => `<th>${c.label}</th>`).join('')
    const td = list
        .map(
            (row) =>
                `<tr>${show
                    .map((c) => {
                        let v = row[c.prop] ?? ''
                        if (c.prop === 'iscancel') v = row[c.prop] ? '是' : '否'
                        return `<td>${v}</td>`
                    })
                    .join('')}</tr>`
        )
        .join('')
    const html = `<table border=1 cellpadding=6 width=100%><thead><tr>${th}</tr></thead><tbody>${td}</tbody></table>`
    const w = window.open('')
    w.document.write(html)
    w.print()
    w.close()
}

const exportPrepaid = () => exportTable(prepaidList.value, preCols.value, '缴费记录.csv')
const printPrepaid = () => printTable(prepaidList.value, preCols.value)
const exportBill = () => exportTable(billList.value, billCols.value, '账单记录.csv')
const printBill = () => printTable(billList.value, billCols.value)

// 分页
const handleSizeChange = (val) => {
    page_params.value.page_size = val
    page_params.value.page = 1
    loadPrepaidList()
}
const handleCurrentChange = (val) => {
    page_params.value.page = val
    loadPrepaidList()
}

// 模拟数据
const loadPrepaidList = () => {
    prepaidList.value = [
        {
            roomcode: '17号楼1层101',
            roomname: '101',
            doorplate: '',
            paid: 1533.1,
            paytypeText: '其他',
            costtypeText: '预存',
            paydate: '2025-09-16 09:49:38',
            lastbalance: -1533.1,
            thisbalance: 0,
            invoicenumber: 'IN2025090019231000007',
            iscancel: false,
            desc: '导入余额重置'
        }
    ]
}

const loadBillList = () => {
    billList.value = [
        {
            scemename: 'testa',
            begindate: '2026-01-26',
            enddate: '2026-01-27',
            realamount: 0.02,
            quantity: 0.09,
            f_BillingQuantityBegin: 3268.39,
            f_BillingQuantityEnd: 3268.48,
            discountamount: 0,
            overdueamount: 0,
            f_MinimalAmountOffsetting: 0,
            lastbalance: -768.05,
            thisbalance: -768.07,
            desc: '空调热量费'
        }
    ]
}

const submitPay = async () => {
    payLoading.value = true
    setTimeout(() => {
        payLoading.value = false
        ElMessage.success('操作成功')
        loadPrepaidList()
    }, 600)
}

const cancelPrepaid = async (row) => {
    await ElMessageBox.confirm('确定取消？')
    row.iscancel = true
    ElMessage.success('已取消')
}

const initChart = () => {
    usageChart = echarts.init(usageChartRef.value)
    usageChart.setOption({
        xAxis: { data: ['1.18', '1.19', '1.20', '1.21', '1.22'] },
        yAxis: {},
        grid: { left: '50px', right: '50px', bottom: '0', containLabel: true },
        series: [{ data: [0, 5.73, 16.13, 24.47, 29.9], type: 'line' }]
    })
    nextTick(() => {
        usageChart.resize()
    })
}

onMounted(() => {
    meterList.value = [
        {
            meterid: '28616',
            meteraddr: '869470071561794',
            metername: '101',
            metertype: 55,
            typeText: '空调',
            linkdate: '2026-01-20 15:00:59',
            meterfields: [
                { f_Text: '能量', f_Unit: 'kWh', f_FieldValue: 0 },
                { f_Text: '锁定状态', f_FieldValue: '初始状态(无任何锁定)' },
                { f_Text: '开关状态', f_FieldValue: '开启' },
                { f_Text: '设定温度', f_Unit: '℃', f_FieldValue: 31.5 },
                { f_Text: '设置风速', f_FieldValue: '低速' },
                { f_Text: '节能模式', f_FieldValue: '关闭' },
                { f_Text: '实时温度', f_Unit: '℃', f_FieldValue: 19.4 },
                { f_Text: '运行状态', f_FieldValue: '正常' },
                { f_Text: '温度锁定上限', f_Unit: '℃', f_FieldValue: 35 },
                { f_Text: '温度锁定下限', f_Unit: '℃', f_FieldValue: 5 },
                { f_Text: '外部温度传感器使能', f_FieldValue: '不使能' },
                { f_Text: '制冷启动计时温度', f_Unit: '℃', f_FieldValue: 25 },
                { f_Text: '制热启动计时温度', f_Unit: '℃', f_FieldValue: 35 },
                { f_Text: '运行模式', f_FieldValue: '制热' },
                { f_Text: '高速运行时间', f_FieldValue: 2742 },
                { f_Text: '中速运行时间', f_FieldValue: 2619 },
                { f_Text: '低速运行时间', f_FieldValue: 42212 },
                { f_Text: '版本号', f_FieldValue: 0 }
            ]
        },
        {
            meterid: '29352',
            meteraddr: '2002202507290103',
            metername: '17-01',
            metertype: 99,
            typeText: '热量表',
            linkdate: '2026-04-10 00:19:11',
            meterfields: [
                { f_Text: '累积热量', f_FieldValue: '3268.48' },
                { f_Text: '累积冷量', f_FieldValue: '725.49' },
                { f_Text: '累积流量', f_FieldValue: 1160.69 },
                { f_Text: '瞬时流量', f_FieldValue: 0 },
                { f_Text: '进水温度', f_FieldValue: '23.74' },
                { f_Text: '回水温度', f_FieldValue: 23.62 },
                { f_Text: '阀门开度', f_FieldValue: 0 },
                { f_Text: 'CSQ', f_FieldValue: 31 },
                { f_Text: '热功率', f_FieldValue: 0 },
                { f_Text: '电压', f_FieldValue: 3.32 }
            ]
        }
    ]

    cmdList.value = [
        { f_ID: 16, f_CommandName: '设备阀门控制' },
        { f_ID: 6, f_CommandName: '重启设备' },
        { f_ID: 31, f_CommandName: '设置开关机' },
        { f_ID: 32, f_CommandName: '设置温度' },
        { f_ID: 33, f_CommandName: '设置风速' },
        { f_ID: 34, f_CommandName: '设置运行模式' },
        { f_ID: 35, f_CommandName: '设置上报周期' },
        { f_ID: 36, f_CommandName: '设置节能模式' },
        { f_ID: 37, f_CommandName: '设置锁定模式' },
        { f_ID: 38, f_CommandName: '设置温度上限' },
        { f_ID: 39, f_CommandName: '设置温度下限' },
        { f_ID: 40, f_CommandName: '启用外部传感器' },
        { f_ID: 41, f_CommandName: '制热启动计时温度' },
        { f_ID: 42, f_CommandName: '制冷启动计时温度' },
        { f_ID: 99, f_CommandName: '设置升级地址' }
    ]

    activeMeterId.value = meterList.value[0].meterid
    handleMeterChange({ name: activeMeterId.value })
    loadPrepaidList()
    loadBillList()
    initChart()
})
</script>

<style scoped>
.room-page {
    padding: 16px;
    background: #fff;
}
.card {
    background: #fff;
    border-radius: 8px;
    padding: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
.card-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 12px;
}
.room-top-card {
    background: #fff;
    padding: 12px 16px;
    border-radius: 8px;
}
.room-info {
    font-size: 14px;
}
.label {
    color: #6979af;
    font-weight: 600;
}
.balance {
    font-size: 20px;
    font-weight: bold;
}
.balance.plus {
    color: #00b271;
}
.balance.minus {
    color: #f53f3f;
}
.mt-4 {
    margin-top: 16px;
}
.ml-4 {
    margin-left: 16px;
}

.pay-row {
    display: flex;
    gap: 16px;
    margin-top: 16px;
    width: 100%;
}
.pay-left {
    width: 25%;
    flex-shrink: 0;
}
.pay-right {
    flex: 1;
    min-width: 0;
}
.pay-right-full {
    width: 100%;
}

.grid-table {
    width: 100%;
    border-collapse: collapse;
}
.grid-table tr {
    border-bottom: 1px solid #f2f2f2;
}
.grid-table .label {
    width: 12%;
    text-align: right;
    padding: 10px 8px;
    background: #fafafa;
    font-weight: 500;
}
.grid-table .value {
    padding: 10px 8px;
    color: #666;
}
.grid-table .highlight {
    color: #009688;
    font-weight: bold;
}

.card-title-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}
.table-tools {
    display: flex;
    gap: 8px;
}
.column-check-wrapper {
    max-height: 380px;
    overflow-y: auto;
    padding: 8px 0;
}
.block-checkbox {
    display: block;
    margin: 6px 10px !important;
}
</style>
